import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-ir',
  templateUrl: './admin-ir.component.html',
  styleUrls: ['./admin-ir.component.css']
})
export class AdminIrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
